import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  // Replace with your Firebase config
  apiKey: "AIzaSyBcOgbVs6P0Q_s02Z7JLFWZacNteYiicYo",
  authDomain: "omnibeauty-d032e.firebaseapp.com",
  projectId: "omnibeauty-d032e",
  storageBucket: "omnibeauty-d032e.firebasestorage.app",
  messagingSenderId: "329227168003",
  appId: "1:329227168003:web:9ee40b3561cfa72e5de136"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Initialize Analytics (only in browser environment and if supported)
let analytics = null;
if (typeof window !== 'undefined') {
  isSupported().then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
    }
  });
}

export { analytics };
export default app;